exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".frame-hopping-page[data-v-0acdad8a]{position:relative;padding:10px}.frame-hopping-page .frame-hopping-table[data-v-0acdad8a] .ivu-form-item{margin:0}", ""]);

// exports
